import { getUserAuditTrail } from '@appt-digital/frontend-api-lib-sheffmed'
import React, { useContext, useEffect, useState } from 'react'
import Paper from '@mui/material/Paper'
import Box from '@mui/material/Box'
import Typography from '../../ui-library/components/Typography'
import { useFormik } from 'formik'
import { productSchema } from '../../config/validation'
import {
  deleteAppUser,
  editAppUser,
  resetAppUser,
} from '../../handlers/requests/users/appUsersHandler'

import { createProduct } from '../../handlers/requests/sheffmed/products'

import ConfirmationModal from '../../ui-library/components/dialogs/ConfirmationModal'
import { AlertContext } from '../../context/AlertContext'
import TextField from '../../ui-library/components/TextField'
import Dropdown from '../../ui-library/components/Dropdown'
import ArrowDropDownIcon from '@mui/icons-material/ArrowDropDown'
import Button from '../../ui-library/components/Button'
import Link from '../../ui-library/components/Link'

import Image from '../../ui-library/components/Image'


import { FaUser } from 'react-icons/fa'
import { MdDeleteForever } from 'react-icons/md'
import { ThemeContext } from '../../ui-library/components/ThemeContext'
import DashboardContainer from '../../ui-library/components/DashboardContainer'

import DropZone from '../../ui-library/components/DropZone'


import TabHeader from '../../ui-library/components/TabHeader'
import { useLocation, useNavigate } from 'react-router-dom'
import toCapitalised from '../../utils/capitaliseString'
import {
  Table,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
} from '../../ui-library/components/DataTable'
import uuid from 'react-uuid'

function AddProduct() {
  const [setLoading] = useState(false)
  const { setAlert } = useContext(AlertContext)
  const [confirmDelete, setConfirmDelete] = useState(false)
  const [confirmReset, setConfirmReset] = useState(false)
  const [audit, setAudit] = useState([])
  const { theme } = useContext(ThemeContext)
  const { state } = useLocation()
  const navigate = useNavigate()
  const initialEdit = {
    title: '',
    summary: '',
    description: '',
    priceDefault: 0,
    priceTierOne: 0,
    priceTierTwo: 0,
    priceTierThree: 0
  }

  const [productImage, setProductImage] = useState()

  useEffect(() => {
    setProductImage(state?.product?.record?.signedUrl)
  }, [])

  const { values, errors, touched, handleBlur, handleChange, handleSubmit } =
    useFormik({
      initialValues: initialEdit,
      validationSchema: productSchema,
      onSubmit: async () => await handleAdd(),
    })
  const handleAdd = async () => {
    let results = await createProduct(values)
    // console.log('handleAdd - results', results)
    // return 

    // setAlert,
    // setLoading(false)
    // navigate('/dashboard/products')

    navigate('/dashboard/products/edit', {
      state: { product: results }
    })

  }
  // useEffect(() => {
  //   const getAuditTrail = async () => {
  //     const res = await getUserAuditTrail(state?.user?.id)
  //     setAudit(res?.data)
  //   }
  //   getAuditTrail()
  // }, [])
  return (
    <>
      <DashboardContainer>
        <TabHeader
          title={'Edit Product'}
          username={
            state?.user?.firstname !== null &&
            state?.user?.firstname !== undefined &&
            state?.user?.lastname !== null &&
            state?.user?.lastname !== undefined &&
            `${toCapitalised(state?.user?.firstname)} ${toCapitalised(
              state?.user?.lastname
            )}`
          }
        >
          <Paper style={theme?.dashboard?.container}>
            <div style={{ display: 'flex', flexDirection: 'row' }}>
              <div>
                <Link
                  type="submit"
                  onClick={() => {
                    navigate('/dashboard/products')
                  }}
                >
                  {`< Back`}
                </Link>
                <Typography source={'h1'} style={{ marginTop: 20 }}>Product Details</Typography>

                <form onSubmit={handleSubmit}>

                    {/* 

                      Title
                      Summary
                      Description <TEXTAREA>
                      Photo
                      Base Price, Tier 1, Tier 2, Tier 3
                    
                    */}

                  <div
                    style={{ display: 'flex', flexDirection: 'column' }}
                  >
                    <Typography source={'h4'} style={{ marginTop: 10 }}>Title</Typography>
                    <TextField
                      type="title"
                      name="title"
                      placeholder="Title"
                      value={values.title}
                      onChange={handleChange}
                      onBlur={handleBlur}
                      errorType={'title'}
                      errors={errors}
                      touched={touched}
                    />
                  </div>
                  <div style={{ display: 'flex', flexDirection: 'column' }}>
                    <Typography source={'h4'} style={{ marginTop: 10 }}>Summary</Typography>
                    <TextField
                        type="summary"
                        name="summary"
                        placeholder="Summary"
                        value={values.summary}
                        onChange={handleChange}
                        onBlur={handleBlur}
                        errorType={'summary'}
                        errors={errors}
                        touched={touched}
                      />
                  </div>
                  <div
                    style={{ display: 'flex', flexDirection: 'column' }}
                  >
                    <Typography source={'h4'} style={{ marginTop: 10 }}>Description</Typography>
                    <TextField
                      type="description"
                      name="description"
                      placeholder="Description"
                      value={values.description}
                      onChange={handleChange}
                      onBlur={handleBlur}
                      errorType={'description'}
                      errors={errors}
                      touched={touched}
                      multiline
                      style={{ height: '100%' }}
                      // minRows={4}
                    />
                  </div>
              
                  <div style={{ display: 'flex', flexDirection: 'row', gap: 10 }}>
                    <Button type="submit" primary>Save</Button>
                  </div>
                </form>
                <ConfirmationModal
                  onAccept={async () => {
                    await deleteAppUser(state?.user?.id, setAlert)
                    navigate('/dashboard/system')
                  }}
                  isOpen={confirmDelete}
                  onRequestClose={() => setConfirmDelete(false)}
                  type={'Delete'}
                  text={'Are you sure you wish to delete this product?'}
                  icon={MdDeleteForever}
                />
              
              </div>
              {/* <div
                style={{
                  margin: 20,
                  borderLeft: '1px solid grey',
                  minHeight: 600,
                }}
              /> */}
              {/* <div style={{ paddingLeft: 30, paddingRight: 30 }}>
                <Typography source={'h2'} style={{ marginTop: 30 }}>
                  Audit Trail
                </Typography>
                {!audit?.length || audit?.length < 1 ? (
                  <Typography source={'p'} style={{ marginTop: 10 }}>
                    No audit trail found
                  </Typography>
                ) : (
                  <TableContainer source={'audit'} theme={theme}>
                    <Table source={'audit'} theme={theme}>
                      <TableHead source={'audit'} theme={theme}>
                        {['Time', 'Action']?.map((header, index) => {
                          return (
                            <TableCell
                              source={'audit'}
                              key={uuid()}
                              theme={theme}
                            >
                              <Typography>{header}</Typography>
                            </TableCell>
                          )
                        })}
                      </TableHead>
                      {audit?.map((item) => {
                        return (
                          <TableRow source={'audit'} theme={theme} key={uuid()}>
                            <TableCell source={'audit'} theme={theme}>
                              {new Date(item?.updatedAt).toLocaleString()}
                            </TableCell>
                            <TableCell source={'audit'} theme={theme}>
                              {item?.description}
                            </TableCell>
                          </TableRow>
                        )
                      })}
                    </Table>
                  </TableContainer>
                )}
              </div> */}
            </div>
          </Paper>
        </TabHeader>
      </DashboardContainer>
    </>
  )
}

export default AddProduct
